export default {
  namespaced: true,
  state: () => ({
    token: sessionStorage.getItem('token') || null,
    user: null
  }),
  mutations: {
    setToken(state, token) {
      state.token = token;
      sessionStorage.setItem('token', token);
    },
    clearToken(state) {
      state.token = null;
      sessionStorage.removeItem('token');
    },
    setUser(state, user) {
      state.user = user;
    }
  },
  actions: {
    login({ commit }, { token, user }) {
      commit('setToken', token);
      commit('setUser', user);
    },
    logout({ commit }) {
      commit('clearToken');
      commit('setUser', null);
    }
  },
  getters: {
    isAuthenticated: state => !!state.token,
    getUser: state => state.user,
    token: state => state.token
  }
};